var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AsoValidarIdentidadeStep.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-516f00f6\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AsoValidarIdentidadeStep.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/funcionario/aso/assinar/AsoValidarIdentidadeStep.vue
// module id = 1311
// module chunks = 45